__webpack_require__.p = "public/plugins/grafana-metricsdrilldown-app/";